import React from 'react';
import { FederatedSeller, useSellerData } from '@fiverr-private/seller_pages_toolbox';
import { Text } from '@fiverr-private/typography';
import { ClockIcon } from '@fiverr-private/icons';
import { Stack } from '@fiverr-private/layout_components';
import { I18n } from '@fiverr-private/i18n-react';

const T_PREFIX = 'seller_page_perseus.professions_page.contact';

const getRespondTimeText = (hours) => (hours === 1 ? `${T_PREFIX}.responds_in_hour` : `${T_PREFIX}.responds_in_hours`);

export const ResponseTimeInfo = () => {
    const { responseTime } = useSellerData(selectSellerSlice);
    const inHours = responseTime?.inHours;

    if (!inHours) {
        return null;
    }

    return (
        <Stack alignItems="center" gap="2" hidden={{ default: true, sm: false }}>
            <ClockIcon size={16} />
            <Text size="b_sm">
                <I18n k={getRespondTimeText(inHours)} params={{ hour: inHours }} />
            </Text>
        </Stack>
    );
};

function selectSellerSlice(seller: FederatedSeller) {
    return {
        responseTime: seller.responseTime,
    };
}
